// extracted by mini-css-extract-plugin
export default {"container":"Vr-z","brandName":"Wr-z","productName":"Xr-z","productNamePdpEnhancements":"Yr-z","breakLongProductName":"Zr-z"};